import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
// import { NEWS } from "../../data/news";

export default function ImportantNews({ siteContent }) {
  const NEWS = siteContent
  const history = useHistory();

  const featured = useMemo(() => {
    const sorted = [...NEWS].sort((a, b) => new Date(b.date) - new Date(a.date));
    const important = sorted.filter((n) => n.important);

    if (important.length >= 2) return important.slice(0, 2);
    if (important.length === 1) {
      const rest = sorted.filter((n) => n.id !== important[0].id);
      return [important[0], ...rest.slice(0, 1)];
    }
    return sorted.slice(0, 2);
  }, []);

  return (
    <section className="section" id="noticias">
      <div className="sectionHead">
        <h2 className="section__title">NOTÍCIAS</h2>
        <button
          className="linkBtn"
          type="button"
          onClick={() => history.push("/noticias")}
        >
          Ver todas →
        </button>
      </div>

      <div className="grid grid--2">
        {featured.map((n) => (
          <article className="card" key={n.id}>
            <h3 className="card__title">{n.title}</h3>
            <p className="card__text">{n.subtitle}</p>

            <button
              className="btn btn--ghost"
              type="button"
              onClick={() => history.push(`/noticias/${n.id}`)}
            >
              LEIA MAIS
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}